<template>
    <div class="main-layout-section admin-portal" :class="[user_data.role_id == 4 ? '' : 'secondary']">
        <AdminHeader @setPodData="setPodData($event)" v-if="user_data.role_id == 3" />
        <SuperAdminHeader v-if="user_data.role_id == 4" />
        <div class="w-logo mb-3">
            <img :src="logo_file" alt="logo" class="w-input-fields animate__animated animate__fadeInUp animate__delay-1s" v-if="logo_file !== '' && logo_file !== null && user_data.role_id !== 4"/>
            <img src="../../assets/images/gamelab-logo.svg" alt="logo" class="w-input-fields animate__animated animate__fadeInUp animate__delay-1s" v-if="user_data.role_id == 4"/>
        </div>

        <div class="main-content">
            <h3 class="page-subheading mb-3 animate__animated animate__fadeInUp animate__delay-1s">Create Report</h3>

            <div class="col-md-11 mx-auto">

                <div class="admin-general-section">
                    
                    <div class="row">
                        <div class="admin-general-section-buttons col-md-12">
                            <router-link :to="dashboard_link" class="admin-general-section-button">
                                Back To Dashboard
                            </router-link>
                        </div>
                        <div class="admin-general-section-buttons col-md-12 mb-3">
                            <router-link :to="dashboard_link" class="alerts-breadcrumb">
                                Dashboard
                            </router-link>
                            <span class="alerts-breadcrumb">></span>
                            <span class="alerts-breadcrumb">Create New Report</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 col-sm-12 alerts-section-heading first d-none">
                            <h5>Create New Report</h5>
                        </div>
                        <div class="col-sm-12">
                            <div class="reports-menu-header">
                                <router-link class="report-menu-header-button" :to="`/common/reports/summary`">Stats</router-link>
                                <router-link class="report-menu-header-button" :to="`/common/reports/status`">Status</router-link>
                                <router-link class="report-menu-header-button" :to="`/common/reports/logs`">Logs</router-link>
                                <router-link class="report-menu-header-button active-report-menu-header-button" :to="`/common/reports/uptime`">Uptime</router-link>
                            </div>
                            <hr class="alerts-border mt-2 mb-3">
                        </div>
                        <div class="col-sm-12 col-md-12">
                            <div class="overflow-auto p-0 m-0">
                                <table id="reports-table" role="table" aria-busy="false" aria-colcount="6" class="table b-table table-striped">
                                    <tbody role="rowgroup">
                                        <tr role="row" class="">
                                            <td aria-colindex="2" role="cell" class="report-td-datetime">
                                                <div class="report-items">
                                                    <span class="report-item-date">
                                                        <input
                                                            type="text"
                                                            value=""
                                                            placeholder="MM/DD/YYYY"
                                                            v-model="report_form.active_start_date" 
                                                            v-mask="date_mask"
                                                        />
                                                    </span>
                                                </div>
                                            </td>
                                            <td aria-colindex="3" role="cell" class="report-td-datetime">
                                                <div class="report-items">
                                                    <span class="report-item-date">
                                                        <input
                                                            type="text"
                                                            value=""
                                                            placeholder="MM/DD/YYYY"
                                                            v-model="report_form.active_end_date" 
                                                            v-mask="date_mask"
                                                        />
                                                    </span>
                                                </div>
                                            </td>
                                            <td aria-colindex="6" role="cell" class="report-td-action">
                                                <div class="report-action-button">
                                                    <button class="btn-sm" @click="handleReportReq">
                                                        Create Report
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <hr class="alerts-border mt-3">
                        </div>
                    </div>


                    <div class="row" ref="summarypdf">
                        <div class="col-md-12 col-sm-12">
                            <b-overlay :show="api_state" rounded="sm" variant="dark" opacity="0.75">
                                <div class="report-container">
                                    <!-- start of games/feedback panel -->
                                    <div class="report-gameplay-feedback-wrapper">

                                        <div class="report-gameplay-feedback">
                                        
                                            <div class="report-gameplay">

                                                <div class="report-panel">
                                                    <div class="report-panel-body">
                                                        <ul class="report-panel-body-list">
                                                            <li class="report-panel-body-list-item item-header">
                                                                <div class="report-panel-body-list-item-text">
                                                                    Uptime
                                                                </div>
                                                                <div class="report-panel-body-list-item-value">
                                                                    Type
                                                                </div>
                                                                <div class="report-panel-body-list-item-value">
                                                                    Minutes
                                                                </div>
                                                            </li>
                                                            <template v-if="Object.prototype.hasOwnProperty.call(report_data, 'uptime') && Object.prototype.hasOwnProperty.call(report_data.uptime, 'data') && Object.prototype.hasOwnProperty.call(report_data.uptime, 'error') && report_data.uptime.error == ''">
                                                                <div class="report-panel-body-list-item-scroll">
                                                                    <li class="report-panel-body-list-item" v-for="(item, index) in report_data.uptime.data" :key="index">
                                                                        <div class="report-panel-body-list-item-text">
                                                                            {{ item.start_time }} - {{ item.end_time }}
                                                                        </div>
                                                                        <div class="report-panel-body-list-item-value">
                                                                            {{ item.status }}
                                                                        </div>
                                                                        <div class="report-panel-body-list-item-value">
                                                                            {{ item.minutes }}
                                                                        </div>
                                                                    </li>
                                                                </div>
                                                                <li class="report-panel-body-list-item item-header"></li>
                                                                <li class="report-panel-body-list-item">
                                                                    <div class="report-panel-body-list-item-text">
                                                                        Avg Uptime
                                                                    </div>
                                                                    <div class="report-panel-body-list-item-value">
                                                                        {{ report_data.uptime.stats.avg_uptime }}
                                                                    </div>
                                                                </li>

                                                                <!-- render pagination -->
                                                                <li class="report-panel-body-list-item item-header"></li>
                                                                <li class="report-panel-body-list-item">
                                                                    <div class="report-item-pagination">
                                                                        <b-pagination
                                                                        v-model="current_page"
                                                                        :total-rows="total_rows"
                                                                        :per-page="per_page" 
                                                                        limit="3"
                                                                        aria-controls="admin-general-table" 
                                                                        align="right"
                                                                        ></b-pagination>
                                                                        <p class="admin-general-table-status-text">{{ status_text }}</p>
                                                                    </div>
                                                                </li>

                                                            </template>
                                                            <template v-else-if="Object.prototype.hasOwnProperty.call(report_data, 'uptime') && Object.prototype.hasOwnProperty.call(report_data.uptime, 'error') && report_data.uptime.error !== ''">
                                                                <li class="report-panel-body-list-item">
                                                                    <div class="report-panel-body-list-item-text" 
                                                                    style="width: 100%;text-align: center;font-size: 15px;font-weight: 600;">
                                                                        {{ report_data.uptime.error }}
                                                                    </div>
                                                                </li>
                                                            </template>
                                                            <template v-else-if="report_form.active_start_date == '' || report_form.active_end_date == ''">
                                                                <li class="report-panel-body-list-item">
                                                                    <div class="report-panel-body-list-item-text" 
                                                                    style="width: 100%;text-align: center;font-size: 15px;font-weight: 600;">
                                                                        Please select a date range to view report.
                                                                    </div>
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                    <!-- end of games/feedback panel -->

                                </div>
                            </b-overlay>
                        </div>
                    </div>
                </div>

            </div>

        </div>

        <!-- start of footer section -->
        <div class="col-md-12 mx-auto">
            <AdminFooter type="inner" v-if="user_data.role_id == 3" />
            <SuperAdminFooter type="inner" v-if="user_data.role_id == 4" />
        </div>
        <!-- end of footer section -->
    </div>
</template>

<script>
import AdminHeader from "@/views/admin/AdminHeader.vue";
import { adminGetReportUptime } from "../../services/AdminService";
import AdminFooter from "@/views/admin/AdminFooter.vue";
import SuperAdminHeader from "@/views/superadmin/SuperAdminHeader.vue";
import SuperAdminFooter from "@/views/superadmin/SuperAdminFooter.vue";
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)
import { requiredIf } from 'vuelidate/lib/validators';
import moment from 'moment';
import moment_timezone from 'moment-timezone';
import { global_config } from "@/config/config.js";

export default {
    name: "UptimeReport-view",
    components: { AdminHeader, AdminFooter, SuperAdminHeader, SuperAdminFooter },
    data() {
        return {
            api_state: false,
            sort_by: 'active_start',
            sort_type: 'desc',
            search_client_id: '',
            user_data: null,
            dashboard_link: '',
            report_form: {
                interval:'custom',
                active_start_date: '',
                active_end_date: '',
                client_id: '',
                lab_id:'',
            },
            date_mask: '##/##/####',
            time_mask: '##:##',
            user_timezone: moment.tz.guess(),
            mtz: moment_timezone,
            report_data : {},
            xds_icons: global_config.XD_ICONS,
            status_text: '',
            per_page: 10,
            current_page: 1,
            total_rows: 0,
        };
    },

    validations: {
        report_form : {
            client_id:{required:false},
            lab_id:{required:false},
            interval:{required:false},
            active_start_date:{required: requiredIf(function(){
                if(this.report_form.interval == 'custom') {
                    return true;
                }
                return false; 
            })},
            active_end_date:{required: requiredIf(function(){
                if(this.report_form.interval == 'custom') {
                    return true;
                }
                return false; 
            })},
        }
    },
    computed: {
        logo_file() {
            return this.$store.getters.getThemeLogo().logo;
        }
    },
    watch: {
        current_page: {
            handler: function(value) {
                this.current_page = value;
                this.handleReportReq('page');
            }
        }
    },

    methods: {
        makeToast(variant = "default", message, message1='') {
            this.$root.$emit("toast_message", {'type' : variant, 'message' : message, 'message1': message1});
        },
        setPodData(obj) {
            this[obj.key] = obj.value;
        },
        setUserData() {
            this.user_data = JSON.parse(localStorage.user_sess_data);
            if(!Object.prototype.hasOwnProperty.call(this.user_data, 'role_id')) {
                this.$router.push("/admin/login");
            }
            this.dashboard_link = this.user_data.role_id == 2 ? '/facilitator/dashboard' : (this.user_data.role_id == 3 ? '/admin/dashboard' : '/superadmin/dashboard');
        },
        handleReportReq(type="default") {
            // fill in client id if user is not superadmin
            if(this.user_data.role_id !== 4) {
                this.report_form.client_id = this.user_data.client_id;
            }
            this.$v.$touch();
            if (this.$v.$invalid && type !== 'initial' && type !== 'page') {
                this.makeToast("error", "Please fill all required fields");
            } 
            else {
                // reset page when create button clicked
                if(type == 'default' || type == 'initial') {
                    this.current_page = 1;
                }

                this.api_state = true;
                let user_data = JSON.parse(localStorage.user_sess_data);
                let data = this.report_form;
                data.token = user_data.token;
                data.start_date = "";
                data.end_date = "";
                if(data.active_start_date !== "" && data.active_end_date !== "") {
                    data.start_date = data.active_start_date;
                    data.end_date = data.active_end_date;
                }
                data.user_timezone = this.user_timezone;
                // add pagination params
                data.length = this.per_page;
                data.page = this.current_page;
                data.load_type = type;
                if(type == 'page') {
                    data.load_type = 'initial';
                }
                adminGetReportUptime(data).then(response => {
                    this.api_state = false;
                    if(Object.prototype.hasOwnProperty.call(response.data, 'current_page')) {
                        this.current_page = response.data.current_page;
                        this.total_rows = response.data.total_rows;
                        this.status_text = response.data.status_text;
                    }
                    if(response.status) {
                        this.report_data = response.data.report;
                    }
                    else {
                        this.makeToast("error", response.message);
                    }
                });
            }
        },
    },

    mounted() {
        this.handleReportReq('initial');
    },
    created() {
        this.setUserData();
    }
};
</script>
<style scoped>
.report-container .report-panel .report-panel-body .report-panel-body-list .report-panel-body-list-item-scroll {
    /* max-height: 300px;
    overflow: hidden;
    overflow-y: auto; */
    margin-top: 7px;
}
.report-container .report-panel .report-panel-body .report-panel-body-list .report-panel-body-list-item-scroll::-webkit-scrollbar {
    width: 15px;
}
.report-container .report-panel .report-panel-body .report-panel-body-list .report-panel-body-list-item-scroll::-webkit-scrollbar-track {
    background: #d3d3d3;
    border-radius: 10px;
}
.report-container .report-panel .report-panel-body .report-panel-body-list .report-panel-body-list-item-scroll::-webkit-scrollbar-thumb {
    background: var(--client-primary);
    border: 4px solid #d3d3d3;
    border-radius: 10px;
}
.report-container .report-panel .report-panel-body .report-panel-body-list .report-panel-body-list-item-scroll::-webkit-scrollbar-thumb:hover {
    background: var(--client-hover);
}
.report-container .report-gameplay-feedback-wrapper .report-gameplay-feedback .report-gameplay {
    width: 100%;
}
.report-container .report-panel .report-panel-body .report-panel-body-list {
    padding: 0;
}
#reports-table > tbody > tr > td.report-td-datetime:nth-child(1) .report-items {
    border-right: unset;
    border-radius: 8px 0px 0px 8px;
}
#reports-table > tbody > tr > td.report-td-datetime:nth-child(2) .report-items {
    border-radius: 0px 8px 8px 0px;
}
#reports-table > tbody > tr > td.report-td-datetime:nth-child(2) {
    padding: 0;
}
#reports-table > tbody > tr > td.report-td-datetime:nth-child(2) .report-items {
    border-right: 2px solid var(--client-primary);
}
.report-container .report-panel .report-panel-body .report-panel-body-list .report-item-pagination {
    width: 100% !important;
    display: flex;
    flex-direction: column;
}
.admin-general-table-status-text {
    margin: 0 !important;
}
#reports-table > tbody > tr > td > .report-items .report-item-date {
    width: 100%;
    border: 0;
}
</style>